//默认导入
const { ccclass, property } = cc._decorator;
import ModuleBase, { ViewLayer, moduleInit, bindButtonClickEvent } from "../../../../framework/core/mvvm/module_base";
import DialogItemTipsView from "./dialog_item_tips_view";

@ccclass
@moduleInit("DialogItemTips")
export default class DialogItemTips extends ModuleBase<DialogItemTipsView, null> {

    protected m_schedule_id: number = 0
    protected m_intentData: any = null
    constructor() {
        super();
        this.package = "public";
        this.layer = ViewLayer.Highest;
        this.windowPrefabResPath = "package/public/dialog_item_tips";
        this.viewType = DialogItemTipsView;
        this.needAnim = false
        this.needViewMask = true
        this.clickAnywhereClose = true
    }

    onShow(intentData) {
        this.view.showPanel(intentData)
    }
    
}